import { createSelector } from 'reselect';

export const getNotifications = (state) => state.notifications;

export const getAllNotifications = createSelector(
    [getNotifications],
    (notifications) => {
        let allNotifications = notifications.ids.map((id) => {
            return notifications.byId[id];
        });
        return allNotifications;
    }
)

export const getNewNotifications = createSelector(
    [getNotifications],
    (notifications) => {
        let newNotifications = notifications.ids.map((id) => {
            if(notifications.byId[id].read === 0){
                return notifications.byId[id];
            }
            return null;
        }).filter((notification) => {
            return notification;
        });
        return newNotifications;
    }
)


// WEBPACK FOOTER //
// ./src/selectors/notification.selector.js